import { CalendarDays, UserRound } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const NONE = "__none__";

export const ItemTaskRow = ({ task, members = [], canWrite, onChanged, itemKey }) => {
  if (!task) return null;
  const update = async (patch) => {
    try {
      await api.put(`/tasks/${task.id}`, patch);
      onChanged();
    } catch (err) { toast.error(apiError(err)); }
  };
  const overdue = task.due_date && task.status !== "done" && task.due_date < new Date().toISOString().slice(0, 10);
  if (!canWrite) {
    return (
      <p className="text-[11px] text-muted-foreground flex items-center gap-3">
        <span className="inline-flex items-center gap-1"><UserRound size={11} /> {task.assignee_name || "Sin responsable"}</span>
        <span className={`inline-flex items-center gap-1 ${overdue ? "text-destructive" : ""}`}><CalendarDays size={11} /> {task.due_date ? new Date(task.due_date + "T00:00:00").toLocaleDateString() : "Sin fecha"}</span>
      </p>
    );
  }
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`item-task-${itemKey}`}>
      <Select value={task.assignee_id || NONE} onValueChange={(v) => update({ assignee_id: v === NONE ? null : v })}>
        <SelectTrigger className="h-7 w-40 text-[11px]" data-testid={`item-assignee-${itemKey}`}>
          <UserRound size={11} className="mr-1 shrink-0 text-muted-foreground" /><SelectValue placeholder="Responsable" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={NONE}>Sin responsable</SelectItem>
          {members.map((m) => <SelectItem key={m.profile_id} value={m.profile_id}>{m.name}</SelectItem>)}
        </SelectContent>
      </Select>
      <label className={`inline-flex items-center gap-1 h-7 rounded-md border bg-background px-2 text-[11px] ${overdue ? "border-destructive/50 text-destructive" : ""}`} title="Fecha límite">
        <CalendarDays size={11} className="text-muted-foreground" />
        <input type="date" value={task.due_date || ""} data-testid={`item-due-${itemKey}`}
          onChange={(e) => {
            const v = e.target.value;
            if (!v) return update({ clear_due_date: true });
            update(task.start_date && v < task.start_date ? { due_date: v, start_date: v } : { due_date: v });
          }}
          className="bg-transparent outline-none text-[11px] w-[108px]" />
      </label>
      {task.status === "done" && <span className="text-[10px] font-semibold text-emerald-600">Tarea completada</span>}
    </div>
  );
};
